import { ArrowRight, Search } from 'lucide-react';
import { Highlight } from '../HeaderSearchRow';
import { TYPE_ICON, badgeOf } from './rowDisplay';

const MUTED = { color: 'var(--strata-text-muted)' };

export const GroupHead = ({ children, right, testid }) => (
  <div data-testid={testid} className="flex items-center justify-between px-4 pt-3 pb-1 text-[10px] uppercase tracking-[0.16em] font-semibold" style={MUTED}>
    <span>{children}</span>{right}
  </div>
);

export const Note = ({ testid, children }) => <div className="px-4 py-2.5 text-xs" style={MUTED} data-testid={testid}>{children}</div>;

const rowCls = (active) => `relative flex items-center gap-3 px-4 py-2 cursor-pointer transition-colors duration-100 ${active ? 'bg-[#4575A8]/[0.08]' : 'hover:bg-[#4575A8]/[0.04]'}`;
const Accent = ({ on }) => (on ? <span className="absolute left-0 top-1.5 bottom-1.5 w-[3px] rounded-r bg-[#4575A8]" /> : null);

// One record: "Type · Title" over its subtitle, the status pill on the right. Never any money.
export function OptionRow({ opt, i, active, q, showType, onPick, onHover, testid }) {
  const Icon = TYPE_ICON[opt.type] || Search;
  const badge = badgeOf(opt.type, opt.row);
  return (
    <li id={`smart-search-opt-${i}`} role="option" aria-selected={active} data-testid={testid} onMouseDown={(e) => e.preventDefault()}
      onClick={onPick} onMouseEnter={onHover} className={rowCls(active)}>
      <Accent on={active} />
      <span className="w-7 h-7 rounded-md flex items-center justify-center shrink-0" style={{ background: 'var(--strata-canvas-soft)' }}>
        <Icon className="w-3.5 h-3.5 text-[#4575A8]" />
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-[13px] truncate" style={{ color: 'var(--strata-text-primary)' }}>
          {showType && <span className="text-[11px] mr-1" style={MUTED}>{opt.row.type_title} ·</span>}
          <span className="font-semibold"><Highlight text={opt.row.title} q={q} /></span>
        </div>
        {opt.row.subtitle && <div className="text-[11px] truncate mt-0.5" style={MUTED}><Highlight text={opt.row.subtitle} q={q} /></div>}
      </div>
      {badge && <span className={`shrink-0 text-[9px] px-1.5 py-0.5 rounded font-medium uppercase tracking-wider ${badge.cls}`}>{badge.text}</span>}
    </li>
  );
}

export function SeeAllRow({ opt, i, active, onPick, onHover }) {
  return (
    <li id={`smart-search-opt-${i}`} role="option" aria-selected={active} data-testid={`topbar-search-see-all-${opt.type}`}
      onMouseDown={(e) => e.preventDefault()} onClick={onPick} onMouseEnter={onHover} className={`${rowCls(active)} text-xs font-semibold text-[#4575A8]`}>
      <Accent on={active} />
      <span className="pl-10">{opt.label}</span><ArrowRight className="w-3 h-3" />
    </li>
  );
}
